import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';

import './index.css';
import './color.css';
import App from './components/App';
import SharedView from './components/SharedView';
import * as serviceWorker from './serviceWorker';

// Redux
import store from './store';

// Simple URL-based routing: detect if this is a share link
function isShareLink() {
    const params = new URLSearchParams(window.location.search);
    return params.has('timetable') && params.has('semester');
}

const queryClient = new QueryClient({});
const root = createRoot(document.getElementById('root'));

// Render SharedView for share links, App for normal use
root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            {isShareLink() ? <SharedView /> : <App />}
        </Provider>
    </QueryClientProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
